const scoreKeys = {
  "Read Aloud": "ra",
  "Repeat Sentence": "rs",
  "Describe Image": "di",
  "Re-tell Lecture": "rl",
  "Summarize Group Discussion": "sgd",
  "Respond to a situation": "rts",
  "Answer Short Question": "asq",
  "Summarize Written Text": "swt",
  "Write Essay": "we",
  "Write Email": "ew",
  "Reading & Writing: Fill in the Blanks": "rwfib",
  "Multiple Choice, Multiple Answers": "mcma",
  "Re-order Paragraphs": "rop",
  "Reading: Fill in the Blanks": "rfib",
  "Multiple Choice, Single Answer": "mcsa",
  "Summarize Spoken Text": "sst",
  "Listening: Multiple Choice, Multiple Answers": "lmcma",
  "Fill in the Blanks": "fib",
  "Highlight Correct Summary": "hcs",
  "Listening: Multiple Choice, Single Answer": "lmcsa",
  "Select Missing Word": "smw",
  "Highlight Incorrect Words": "hiw",
  "Write from Dictation": "wfd",
};

const finiteOrZero = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getQuestionTypeRawScore = (scores = {}, questionTypeName = "") => {
  const key = scoreKeys[questionTypeName];
  if (!key) return { obtained: 0, available: 0 };

  return {
    obtained: finiteOrZero(scores[`${key}Obtain`]),
    available: finiteOrZero(scores[`${key}Total`]),
  };
};

export const calculateQuestionTypeScore = (scores, questionTypeName) => {
  const { obtained, available } = getQuestionTypeRawScore(scores, questionTypeName);
  if (available <= 0) return null;

  const ratio = Math.min(1, Math.max(0, obtained / available));
  return Math.min(90, Math.max(10, Math.round(ratio * 90)));
};

export const QUESTION_TYPE_SCORE_KEYS = scoreKeys;
